import { MERCHANT } from "constants/action-types";
import {
    IMerchantDefaultAllocationDimensionsPreference,
    updateableMerchantDefaultAllocationDimensionsPreferenceFields,
} from "constants/merchant";
import { FluxStandardAction as Action } from "flux-standard-action";

export type GetMerchantDefaultAllocationDimensionsPreferenceRequestAction = Action<
    {
        merchantId: string;
    },
    {}
>;
export const getMerchantDefaultAllocationDimensionsPreferenceRequest = (
    merchantId: string
): GetMerchantDefaultAllocationDimensionsPreferenceRequestAction => ({
    meta: {},
    payload: { merchantId },
    type: MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.GET.REQUEST,
});

export type GetMerchantDefaultAllocationDimensionsPreferenceCompleteAction = Action<
    IMerchantDefaultAllocationDimensionsPreference | Error,
    {}
>;
export const getMerchantDefaultAllocationDimensionsPreferenceComplete = (
    payload: IMerchantDefaultAllocationDimensionsPreference | Error
): GetMerchantDefaultAllocationDimensionsPreferenceCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.GET.COMPLETE,
});

export interface IUpdateMerchantDefaultAllocationDimensionsPreference
    extends Partial<
        Pick<
            IMerchantDefaultAllocationDimensionsPreference,
            keyof typeof updateableMerchantDefaultAllocationDimensionsPreferenceFields
        >
    > {}
export type UpdateMerchantDefaultAllocationDimensionsPreferenceRequestAction = Action<
    {
        merchantId: string;
        allocation_dimensions: IUpdateMerchantDefaultAllocationDimensionsPreference;
    },
    {}
>;
export const updateMerchantDefaultAllocationDimensionsPreferenceRequest = (
    merchantId: string,
    allocation_dimensions: IUpdateMerchantDefaultAllocationDimensionsPreference
): UpdateMerchantDefaultAllocationDimensionsPreferenceRequestAction => ({
    meta: {},
    payload: { merchantId, allocation_dimensions },
    type: MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.UPDATE.REQUEST,
});

export type UpdateMerchantDefaultAllocationDimensionsPreferenceCompleteAction = Action<
    IMerchantDefaultAllocationDimensionsPreference | Error,
    {}
>;
export const updateMerchantDefaultAllocationDimensionsPreferenceComplete = (
    payload: IMerchantDefaultAllocationDimensionsPreference | Error
): UpdateMerchantDefaultAllocationDimensionsPreferenceCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.UPDATE.COMPLETE,
});
